module.exports = ".table tbody tr td a {\n  text-decoration: none;\n  color: black; }\n\n.table tbody tr td a:hover {\n  color: #646464;\n  text-decoration: none;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/billing-control/bc-expired-1-x/bc-expired-1-x.component.scss
// module id = ./src/app/billing-control/billing-control/bc-expired-1-x/bc-expired-1-x.component.scss
// module chunks = main